import React, { useState } from 'react';
import ListIntervals from './ListIntervals';
import Calendar from './Calendar';
import { allHours, availableHours, nextDaysAvailable, nextDayAvailable } from '../assets/timeCalculations';

const SecondStep = ({ details, handleChange, setDetails, classes }) => {
	const [intervals, setIntervals] = useState();
	const { nume, email, telefon } = details;

	const showIntervals = (number) => (number == 0 ? setIntervals(availableHours) : setIntervals(allHours));

	return (
		<>
			<div>
				<div className={classes["form-group"]}>
					<label>
						Nume Complet<span className="required-asterisk"> *</span>
					</label>
					<input name="nume" type="text" value={nume} className={classes["form-control"]} onChange={handleChange} />
				</div>
				<div className={classes["form-group"]}>
					<label>
						Email<span className="required-asterisk"> *</span>
					</label>
					<input name="email" type="email" value={email} className={classes["form-control"]} onChange={handleChange} />
				</div>
				<div className={classes["form-group"]}>
					<label>
						Telefon<span className="required-asterisk"> *</span>
					</label>
					<input name="telefon" type="tel" value={telefon} className={classes["form-control"]} onChange={handleChange} />
				</div>
				<p className={classes["step-two__intro"]}>Selectează-ți ziua și ora la care dorești să ne vizitezi.</p>
			</div>
			<Calendar
				days={nextDaysAvailable}
				handleChange={handleChange}
				showIntervals={showIntervals}
				selectedOption={nextDayAvailable}
				setDetails={setDetails}
				classes={classes}
			/>
			<ListIntervals details={details} intervals={intervals ?? availableHours} handleChange={handleChange} classes={classes} />
		</>
	);
};

export default SecondStep;
